import GuidePage from "./GuidePage";

export const GuidePageConfig = {
  routes: [
    {
      path: "/guide",
      exact: true,
      component: GuidePage,
    },
  ],
};
